"use client"

import { useRouter } from "next/navigation"
import { RouterProvider } from "react-aria-components"

export default function ClientRouter({
  children,
}: {
  children: React.ReactNode
}) {
  const router = useRouter()

  // @ts-ignore
  return <RouterProvider navigate={router.push}>{children}</RouterProvider>
}
